import React from 'react'
import styled from 'styled-components'

const ImageContainer = styled.div`
    display: inline-block;
    position: relative;
    background-color: var(--default-primary-colour);
    height: fit-content;
    width: 100%;
    transition: opacity 250ms ease-in-out;
    z-index: 1;
    
    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        background-image: linear-gradient(
            to top,
            ${props => props.colour || 'var(--primary-colour)'} 10%,
            rgba(0, 0, 0, 0)
        );
    }
 
    &:hover {
        opacity: 1;
        transition: opacity 250ms ease-in-out;
    }
`

const Image = styled.img`
    object-fit: cover;
`

export const ImageWithFade = ({width, height, image, style, colour}) => {
  return (
    <ImageContainer colour={colour}>
        <Image width={width ?? '100%'} height={height} src={image}/>
    </ImageContainer>
  )
}
